import React from "react";
import { useTranslation } from "react-i18next";
import Button from "../common/Button";
import Modal from "../common/Modal";
import { color, radius } from "../../styles/theme";

/**
 * Simple thumbnail-grid attachments viewer — proof files attached to a
 * dispute. Click a thumbnail to open the full file in a new tab. Lighter
 * than mobile's full-screen MediaPlayer, appropriate for a handful of proof
 * images rather than an event media gallery.
 */
const AttachmentsModal = ({ attachments, onClose }) => {
  const { t } = useTranslation(["disputes", "common"]);
  return (
  <Modal title={t("attachmentsModal.title")} onClose={onClose} maxWidth={420} footer={<Button variant="secondary" onClick={onClose}>{t("common:actions.close")}</Button>}>
    <div style={s.grid}>
      {attachments.map((att) => (
        <a key={att.Id ?? att.FileUrl} href={att.FileUrl} target="_blank" rel="noreferrer" style={s.thumbLink}>
          <img src={att.FileUrl} alt="" style={s.thumb} />
        </a>
      ))}
    </div>
  </Modal>
  );
};

const s = {
  grid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(96px, 1fr))", gap: 10 },
  thumbLink: { display: "block", borderRadius: radius.sm, overflow: "hidden", border: `1px solid ${color.border}` },
  thumb: { width: "100%", height: 96, objectFit: "cover", display: "block" },
};

export default AttachmentsModal;
